import jwtDecode from "jwt-decode";

import { IJwtMember } from "@/v2/types/Auth/IJwtMember.interface";

import { clearPersistedImpersonation } from "./clearPersistedImpersonation";
import { IMPERSONATION_TOKEN_KEY } from "./constants";

/**
 * Reads the impersonation session persisted in localStorage (so it survives
 * page reloads).
 *
 * Returns the stored `jwt`, the decoded impersonated `user`, and `ownerSub`
 * (the `sub` of the real user who started the impersonation). Returns `null`
 * and clears the entry when nothing is stored, the token has expired, or the
 * stored value cannot be parsed / decoded.
 */
export const readPersistedImpersonation = (): {
  jwt: string;
  user: IJwtMember;
  ownerSub: string;
} | null => {
  const raw = localStorage.getItem(IMPERSONATION_TOKEN_KEY);

  if (!raw) return null;

  try {
    const { jwt, ownerSub } = JSON.parse(raw) as { jwt: string; ownerSub: string };
    const user = jwtDecode(jwt) as IJwtMember;

    if (user.exp * 1000 <= Date.now()) {
      clearPersistedImpersonation();
      return null;
    }

    return { jwt, user, ownerSub };
  } catch {
    clearPersistedImpersonation();
    return null;
  }
};
